<div fxLayout="column" fxLayoutAlign="stretch">

  <div class="filter-toolbar" *ngIf="readWrite">
    <div fxLayout="row" fxLayoutAlign="end center" fxFlexFill>
      <div class="layout padding-right-md">
        <button mat-icon-button matTooltip="Add files" routerLink="upload">
          <mat-icon>note_add</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <ifb-application-notes-sidenav [applicationId]="data.application?.id" [notes]="data.application?.notes" [initiator]="data.userCurrent" [saveOnDemand]="true" [innerSidenavAndTabbed]="true" [hiddenButton]="!data.application">
    <ng-container *ngTemplateOutlet="main"></ng-container>
  </ifb-application-notes-sidenav>

  <ng-template #main>
    <ifc-app-scroll-container [default]="true" [@routerTransition]="'fly'">
      <div class="table-container">

        <div class="message-box info" *ngIf="!data.documentQueryResult || !data.documentQueryResult.totalCount"
          fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start center">
          <mat-icon class="icon">info</mat-icon>
          <span>No data found</span>
        </div>

        <table *ngIf="data.documentQueryResult.totalCount" mat-table matSort [dataSource]="dataSource" (matSortChange)="sortData()" aria-label="Application documents list">
          <ng-container matColumnDef="createdOn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="createdOn"> Date </th>
            <td mat-cell *matCellDef="let document" class="table-cell">
              <span>{{document.uploadDate | date:"medium"}}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="filename">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="filename"> Name </th>
            <td mat-cell *matCellDef="let document" class="table-cell">
              <span>{{document.filename}} ({{document.length | filesize}})</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="category"> Type </th>
            <td mat-cell *matCellDef="let document" class="table-cell">
              {{getCategory(document.category)}} </td>
          </ng-container>

          <ng-container matColumnDef="actions" stickyEnd>
            <th mat-header-cell *matHeaderCellDef style="width: 40px"></th>
            <td mat-cell *matCellDef="let row">
              <div fxLayout="row" fxLayoutAlign="center start">
                <button mat-icon-button class="action-icon" (click)="download(row.id, data.application?.id)">
                  <mat-icon>get_app</mat-icon>
                </button>
                <button *ngIf="readWrite" mat-icon-button class="action-icon" (click)="delete(row.id, data.application?.id, row.filename)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true" class="table-header"></tr>
          <tr mat-row *matRowDef="let row; columns: tableColumns;" class="clickable-row"></tr>
        </table>
      </div>
    </ifc-app-scroll-container>

    <div [hidden]="data.documentQueryResult.totalCount <= 10">
      <mat-paginator #paginator showFirstLastButtons [length]="data.documentQueryResult.totalCount"
        [pageSizeOptions]="[10, 20, 50]" [pageSize]="20" (page)="setPage()"></mat-paginator>
    </div>
  </ng-template>
</div>
